import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  Chainlkbkk6tcx8wg as Chain,
  Assign2nr5v5j409ffp as Assign,
  ListAppend2l1q2g9n9gupy as ListAppend,
  ListRemoveInstances18gi59vc9xu0e as ListRemoveInstances,
} from './Modification.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ModificationBuilderClass;
function ModificationBuilder() {
  if (ModificationBuilderClass === VOID) {
    class $ {
      constructor() {
        this.d44_1 = ArrayList().w();
      }
      o1r() {
        if (this.d44_1.p1() === 1)
          return this.d44_1.q1(0);
        else
          return Chain().j42(this.d44_1);
      }
      e44(_this__u8e3s4, value) {
        this.d44_1.v(_this__u8e3s4.f44(Assign().n42(value)));
      }
      g44(_this__u8e3s4, item) {
        this.d44_1.v(_this__u8e3s4.f44(ListAppend().c43(listOf(item))));
      }
      h44(_this__u8e3s4, item) {
        this.d44_1.v(_this__u8e3s4.f44(ListRemoveInstances().h43(listOf(item))));
      }
      i44(_this__u8e3s4, items) {
        this.d44_1.v(_this__u8e3s4.f44(ListRemoveInstances().h43(items)));
      }
    }
    initMetadataForClass($, 'ModificationBuilder', ModificationBuilder);
    ModificationBuilderClass = $;
  }
  return ModificationBuilderClass;
}
//region block: exports
export {
  ModificationBuilder as ModificationBuilderuhgnvnxpchbi,
};
//endregion

//# sourceMappingURL=ModificationBuilder.mjs.map
